export class Rating {

  index: number;
  label: string;
  score: number;
  stars: number;

  constructor(public data: any) {
    if (data) {
      const json: JSON = data;

      this.index = json['qindex'];
      this.label = json['qlabel'];
      this.score = json['qscore'];
      this.stars = json['stars'];
    }
  }
}

/*
 "qindex": 3,
 "qlabel": "Time Taken to Correct Items",
 "qscore": 5.3,
 "stars": 5.5
 */



// WEBPACK FOOTER //
// ./src/app/model/rating.ts